module.exports = __webpack_public_path__ + "static/heroslide-4-7dc0f37cadf863beb009af27463d310d.jpeg";